import Controller from "./holidays.controller";
import template from "./holidays.html";

const holidays = {
  template,
  controller: Controller,
};

export default holidays;



// WEBPACK FOOTER //
// ./src/pages/holidays/holidays.component.js